import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const vegetationEntries: RawTilesetEntry[] = [
	{
		key: "Tree",
		animations: [
			{
				loop: true,
				height: 2,
				frames: [{ filename: "Tree_1.png", interval: 0 }],
			},
			{
				loop: true,
				height: 2,
				frames: [{ filename: "Tree_2.png", interval: 0 }],
			},
		],
	},
	{
		key: "GrassTiledFloor",
		animations: [
			{
				loop: true,
				frames: [{ filename: "Grass.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 1,
				frames: [{ filename: "Grass.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 2,
				frames: [{ filename: "Grass.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 3,
				frames: [{ filename: "Grass.png", interval: 0 }],
			},
		],
	},
	{
		key: "Plant",
		animations: [
			{
				height: 1.3,
				loop: true,
				frames: [{ filename: "Plant1.png", interval: 0 }],
			},
			{
				height: 1.3,
				loop: true,
				frames: [{ filename: "Plant2.png", interval: 0 }],
			},
		],
	},
	{
		key: "PottedPlant",
		sprite: "PottedPlant.png",
	},
	{
		key: "DeadPlant",
		sprite: "PlantDebris.png",
	},
];
